import { Rise, RevealLine, SectionLabel } from "./Motion";

const promoters = [
  {
    name: "Shah Group",
    role: "Promoter Group",
    note: "A promoter group bringing capital strength and established industry standing to Venus Green's EPC mandate.",
    initials: "SG",
  },
  {
    name: "Mr. Anant Moona",
    role: "Promoter",
    note: "Drives Venus Green's contracting strategy and delivery partnerships across power transmission and infrastructure projects.",
    initials: "AM",
  },
  {
    name: "Mr. Prashant Moona",
    role: "Promoter",
    note: "Brings decades of hands-on experience in power transmission and EPC delivery, with deep PSU and government relationships.",
    initials: "PM",
  },
];

export default function Leadership() {
  return (
    <section
      id="leadership"
      className="bg-white py-24 lg:py-36"
      data-testid="leadership-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <SectionLabel>04 — Leadership</SectionLabel>
        <h2 className="mt-8 max-w-3xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-vg-primary sm:text-5xl lg:text-6xl">
          <RevealLine>Guided by promoters with</RevealLine>
          <RevealLine delay={0.08}>~25 years in the field.</RevealLine>
        </h2>
        <Rise delay={0.15} className="mt-6 max-w-2xl text-base leading-relaxed text-vg-muted lg:text-lg">
          Strong working relationships with major PSUs, government agencies and
          leading private EPC companies form the foundation of Venus Green&apos;s
          order pipeline and delivery credibility.
        </Rise>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {promoters.map((p, i) => (
            <Rise
              key={p.name}
              delay={i * 0.1}
              className="group flex h-full flex-col rounded-sm border border-vg-border bg-vg-bgalt p-8 transition-colors duration-500 hover:border-vg-secondary lg:p-10"
            >
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-vg-primary font-display text-xl font-semibold text-vg-accent">
                {p.initials}
              </div>
              <div className="mt-8 text-xs font-medium uppercase tracking-[0.2em] text-vg-secondary">
                {p.role}
              </div>
              <h3 className="mt-2 font-display text-2xl font-semibold text-vg-primary">
                {p.name}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-vg-muted">
                {p.note}
              </p>
            </Rise>
          ))}
        </div>
      </div>
    </section>
  );
}
